<template>
  <section>
    <v-layout>
      <router-view></router-view>
    </v-layout>
  </section>
</template>

<script>
// import "./assets/styles/styles.css";

export default {
  name: "app",
  data: () => ({}),
  methods: {},
  created: function() {}
}
</script>

<style lang="stylus">
@import '../../stylus/main';
</style>
